import { reportEvent as reportEventV1 } from '@stitch-fix/event-reporter/legacy';
import pkg from '../../../package.json';
import { SearchEvent } from './types';
const eventDefaults = {
  source_app: pkg.name
};
const trackEvent = (event: SearchEvent) => {
  reportEventV1({
    event: {
      ...eventDefaults,
      ...event
    }
  });
};
export default trackEvent;